import * as notifications from './notifications';
import * as discusssions from './discussions';
import * as courseOutline from './courseOutline';

export const SIDEBARS = {
  [courseOutline.ID]: {
    ID: courseOutline.ID,
    Sidebar: courseOutline.Sidebar,
    Trigger: courseOutline.Trigger,
    LAYOUT: courseOutline.LAYOUT,
  },
  [notifications.ID]: {
    ID: notifications.ID,
    Sidebar: notifications.Sidebar,
    Trigger: notifications.Trigger,
    LAYOUT: notifications.LAYOUT,
  },
  [discusssions.ID]: {
    ID: discusssions.ID,
    Sidebar: discusssions.Sidebar,
    Trigger: discusssions.Trigger,
    LAYOUT: discusssions.LAYOUT,
  },
};

export const SIDEBAR_ORDER = [
  courseOutline.ID,
  discusssions.ID,
];
